import {
    $get,
    $post
  } from '@/utils/http'
  //巡视巡察
export default {
    //中央
    getCenter() {
      return $post('/portal/websit/centralInfo/listPatrolInfo')
  },
  // 中央详情
  getCenter1(params) {
    return $post('/portal/websit/centralInfo/getPatrolInfoById',params)
},
  // 北京接口
  getBeijing1(params) {
    return $get('/common/dict/item-list',params)
  },
//    北京
getBeijing(params) {
    return $post('/portal/websit/beijingInfo/listPatrolInfo',params)
  },
  // 北京详情
  getBeijing2(params) {
    return $post('/portal/websit/beijingInfo/getPatrolInfoById',params)
  },
  // 集团专题
  getGroup() {
    return $post('/portal/websit/groupInfo/listSubject')
  },
  // 查询集团动态列表
  getGroup1(params) {
    return $post('/portal/websit/groupInfo/listGroupInfo',params)
  },
  // 集团详情
  getGroup2(params) {
    return $post('/portal/websit/groupInfo/getGroupInfoById',params)
  },
  }